/* eslint-disable */
import ENV from "./constants/environment";

__webpack_public_path__ = ENV.PUBLIC_PATH;

/* eslint-enable */
